/* eslint-disable @typescript-eslint/no-explicit-any */
import { DROPDOWN_TAG_ICON, ONE_LINE } from 'assets/images'
import { useOnClickOutside } from 'hooks'
import { useRef, useState } from 'react'
import SelectCustomGuildRaceStyled from './styled'
import { GUILD_MESSAGE } from 'i18n/constants'
import { useTranslation } from 'react-i18next'

interface PropsSelectCustom {
  nameSelect?: string
  imgSelect?: any
  dataSelect: any
  onSelected: (item: any) => void
  customClass?: string
  disabled?: boolean
  isFiltered?: boolean
  isShowIcon?: boolean
  onClickSelect?: (val: any) => void
  type: string
  icon?: string
}

function SelectCustomGuildRace({
  nameSelect,
  dataSelect,
  onSelected,
  customClass = '',
  disabled,
  isShowIcon = false,
  icon = '',
  onClickSelect,
  type,
}: PropsSelectCustom) {
  const { t } = useTranslation()
  const selectRef = useRef(null)
  const [show, setShow] = useState(false)

  useOnClickOutside(selectRef, e => {
    if (e.target == selectRef.current) {
      return
    }
    setShow(false)
  })

  const handleActionClick = async (e: React.MouseEvent) => {
    e.stopPropagation()
    onClickSelect?.({ type: 'MODAL', options: [] })
  }

  return (
    <SelectCustomGuildRaceStyled>
      <div
        className={`select-box-customs ${customClass}`}
        onClick={e => {
          if (e.target === e.currentTarget) {
            handleActionClick(e)
          }
        }}
        ref={selectRef}
      >
        <span
          className='select-name'
          onClick={e => {
            if (e.target === e.currentTarget) {
              handleActionClick(e)
            }
          }}
        >
          {!!icon && (
            <img className='mr-2' width={type === 'NFT' ? '25px' : '18px'} height={type === 'NFT' ? '25px' : '18px'} alt='icon' src={icon} />
          )}
          {dataSelect?.find((opt: any) => opt.value === nameSelect)?.name ?? nameSelect}
        </span>
        {!disabled && (
          <img
            className={!show ? 'select-drop-icon ' : 'select-drop-icon up-down-icon '}
            src={DROPDOWN_TAG_ICON}
            alt=''
          />
        )}
        <img src={ONE_LINE} alt='' className='orange-line position-absolute' />
        {show && !disabled && (
          <ul className='select-content-dropdown'>
            {dataSelect?.length ? (
              dataSelect.map((item: any, index: any) => (
                <li
                  key={index}
                  onClick={() => {
                    onSelected(item)
                    setShow(false)
                  }}
                  className={`li-item ${nameSelect == item?.name ? 'active' : ''}`}
                >
                  <div>{isShowIcon && item.icon}</div>
                  <div>{item?.name}</div>
                </li>
              ))
            ) : (
              <li
                className='li-item'
              >
                <div>{t(`${GUILD_MESSAGE}.noData`)}</div>
              </li>
            )}
            <div className='bottom_line'></div>
          </ul>
        )}
      </div>
    </SelectCustomGuildRaceStyled>
  )
}
export default SelectCustomGuildRace
